export default __webpack_public_path__ + "static/media/EM1080.34I-27370_-16462_0.eade2c09.jpg";